import * as joint from "jointjs";

export var graph = new joint.dia.Graph();
